<template>
  <div class="_plan_item">
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <!-- <img src="https://www.7859888tp.com/750-50.gif" /> -->
    </div>
    <p class="plan_item_title">
      <span>【彩霸王】 单双四肖</span>
    </p>
    <ul class="fs4">
      <li
        v-for="(el, i) in data.list"
        :key="i"
        :class="{
          li_win: el.ifWin,
        }"
      >
        <div class="qi fs3">
          <span>{{ el.qiShu }}期:</span>
          <!--  -->
          <span class="">五行:</span>
          <span class="color2">
            【<span v-for="(num, numIndex) in el.yuCe.wuXing" :key="numIndex">
              <span :class="{ win: getNumWx(el.code) === num }">{{
                num.yuCe || num
              }}</span> </span
            >】
          </span>
          <!--  -->
          <span class="winText" v-if="el.ifZuiXin">等开</span>
          <span class="winText" v-else
            >开：{{ getNumSx(el.code, el.qiShu) }} {{ el.code
            }}{{ el.ifWin ? "准" : "错" }}</span
          >
        </div>
        <!-- <span class="name">单双二肖</span> -->
        <div
          :class="{
            suck: false,
          }"
        >
          <div class="fs4">
            <div class="fs4">
              <span class="">策防: </span>
              <span class="color2">
                【<span
                  v-for="(num, numIndex) in el.yuCe.ceFang"
                  :key="numIndex"
                >
                  <span
                    :class="{
                      win: el.shuXingList?.ceFang[numIndex].ifWin,
                    }"
                    >{{ num.yuCe || num }}</span
                  >
                  <span v-if="numIndex < el.yuCe.ceFang.length - 1"
                    >.
                  </span> </span
                >】
              </span>
            </div>
            <div class="fs4">
              <span class="">主博: </span>
              <span class="color2">
                【<span
                  v-for="(num, numIndex) in el.yuCe.zhuBo"
                  :key="numIndex"
                >
                  <span
                    :class="{
                      win: el.shuXingList?.zhuBo[numIndex].ifWin,
                    }"
                    >{{ num.yuCe || num }}</span
                  >
                  <span v-if="numIndex < el.yuCe.ceFang.length - 1"
                    >.
                  </span></span
                >】
              </span>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script setup>
import top from "@/assets/img/top.gif";
import { toRefs } from "vue";
import { getNumSx, getNumWx } from "../../utils";

function jsonp(data) {
  return JSON.parse(data);
}

function isWin(el) {
  return (
    !el.yuCe.ceFang.includes(el.shengXiao) &&
    !el.yuCe.zhuBo.includes(el.shengXiao) &&
    !el.ifZuiXin
  );
}

const props = defineProps({
  data: Object,
});

const { data } = toRefs(props);
</script>
      
      <style lang="scss" scoped>
.title {
  text-align: center;
  background-color: #009788;
  font-size: 25px;
  font-weight: bold;
  padding: 6px 0;
}
._plan_item {
  border: 1px solid #009788;
  .plan_item_advertisement {
    img {
      width: 100%;
      height: 40px;
      display: block;
    }
  }
  .plan_item_title {
    font-weight: bold;
    text-align: center;
    background: #3e73fe;
    padding: 6px 0;
    color: #fff !important;
    img {
      width: 30px;
      height: 30px;
    }
  }
  ul {
    background-color: #eee;
    li {
      text-align: center;
      padding: 12px 30px;
      font-weight: bold;
      justify-content: center;
      .win {
        background-color: #ffff00;
        color: red;
      }
      .value {
      }
      &:not(:last-child) {
        border-bottom: 2px solid #d2d2d2;
      }
    }
    .li_win {
      .winText {
        color: #309631;
      }
    }
    .suck {
      text-decoration-line: line-through;
    }
  }
}
.tip {
  text-align: center;
  margin: 8px 0;
  font-weight: bold;
  display: flex;
  justify-content: space-around;
}
</style>